export default class SecurityManagerService {
  /* @ngInject */
  constructor(User, $rootScope, $q, $http, $cookies, $window) {
    this.User = User;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$http = $http;
    this.$cookies = $cookies;
    this.$window = $window;
  }

  authenticate(email, password) {
    return this.$http
      .post(`${process.env.SERVER_URL}/api/auth`, { email, password })
      .then((response) => new this.User(response.data));
  }

  isAuthenticated() {
    const accessToken = this.getAccessToken();
    return accessToken && accessToken.token && new Date(accessToken.expirationDate) > new Date();
  }

  storeCredentials(accessToken, rememberMe) {
    this.$cookies.putObject("proposal_software_access_token", accessToken, {
      expires: rememberMe ? accessToken.expirationDate : undefined,
      secure: process.env.ENV === "prod" || process.env.ENV === "staging",
    });
  }

  removeCredentials() {
    this.$cookies.remove("proposal_software_access_token");
  }

  getAccessToken() {
    return this.$cookies.getObject("proposal_software_access_token");
  }

  loadUser() {
    return this.User.get().then((user) => {
      this.$rootScope.user = user;
      return user;
    });
  }

  getUser() {
    return this.$rootScope.user instanceof this.User ? this.$q.resolve(this.$rootScope.user) : this.loadUser();
  }

  refreshUser() {
    return this.loadUser().then((user) => {
      const slug = this.$rootScope.organization
        ? this.$rootScope.organization.slug
        : this.$rootScope.user.defaultOrganization.slug;
      this.$rootScope.organization = this.$rootScope.user.getOrganization(slug);
      this.$rootScope.$broadcast("refreshUser");
      this.$rootScope.$broadcast("refreshOrganization");

      return user;
    });
  }

  signUp(name, surname, email, password, locale) {
    return this.User.create(name, surname, email, password, locale);
  }

  resetPassword(email) {
    return this.User.resetPassword(email).then();
  }

  verifyEmail(verificationEmailToken) {
    return this.User.verifyEmail(verificationEmailToken).then();
  }

  signout(callback) {
    this.removeCredentials();
    this.$rootScope.user = null;
    this.$rootScope.organization = null;
    if (typeof callback === "function") callback();
  }
}
